export default __webpack_public_path__ + "static/media/image1.91932be6.png";